// CollapseList.tsx
import React, { useState } from 'react';
import * as Collapse from '../../styles/lib/collapse';
import * as Buttons from '../../styles/lib/buttons';
import Edit from '../../assets/buttons/edit.svg';
import Trash from '../../assets/buttons/trash.svg';
import Close from '../../assets/icons/close_clean.svg';
import Check from '../../assets/icons/check_clean.svg';
import Person from '../../assets/icons/person.svg';
import { Utils } from '../../utils/functions';
import { ParallelList } from '../../styles/lib/lists';
import { CollapseListProps } from '../../interfaces';
import { format } from 'date-fns';
import { Lock, Trash2, Unlock } from 'lucide-react';
import * as S from './styles';

const CollapseList: React.FC<CollapseListProps> = ({
  id,
  nome,
  qtdUsuarios,
  ativo,
  permissionsProfile,
  permissoes,
  log,
  perfilRevenda,
  onEditButtonClick,
  onDeactivateButtonClick,
  onRemoveButtonClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const handleToggleStatusClick = () => {
    onDeactivateButtonClick({
      id,
      nome,
      qtdUsuarios,
      ativo,
      permissionsProfile,
      permissoes,
      log,
      perfilRevenda,
    });
  };

  const arrowClass = isExpanded ? 'arrow-up' : 'arrow-down';

  const handleEditButtonClick = () => {
    onEditButtonClick({
      id,
      nome,
      qtdUsuarios,
      ativo,
      permissionsProfile,
      permissoes,
      log,
      perfilRevenda,
    });
  };

  const handleRemoveButtonClick = () => {
    if (onRemoveButtonClick) {
      onRemoveButtonClick({
        id,
        nome,
        qtdUsuarios,
        ativo,
        permissionsProfile,
        permissoes,
        log,
        perfilRevenda,
      });
    }
  };

  return (
    <S.CollapseWrapper className={isExpanded ? 'active' : ''}>
      <Collapse.List
        onClick={toggleExpansion}
        className={isExpanded ? 'active' : ''}
      >
        <Collapse.Content>
          <h4>
            {Utils.capitalizeFirstLetters(nome)}
            <span className="badge flex">
              <img src={Person} width={12} />
              <p> {qtdUsuarios}</p>
            </span>
          </h4>

          <div className="flex container-buttons" style={{ gap: '3%' }}>
            <Buttons.IconButton
              className="edit"
              onClick={e => {
                e.stopPropagation();
                handleEditButtonClick();
              }}
            >
              <img src={Edit} width={16} />
              Editar
            </Buttons.IconButton>
            <Buttons.IconButton
              className={ativo ? 'deactivate' : 'reactivate'}
              onClick={e => {
                e.stopPropagation();
                handleToggleStatusClick();
              }}
              style={{ minWidth: '100px' }}
            >
              {ativo ? <Lock size={16} /> : <Unlock size={16} />}
              {ativo ? 'Desativar' : 'Reativar'}
            </Buttons.IconButton>
            <Buttons.IconButton
              className="danger-outline"
              onClick={e => {
                e.stopPropagation();
                handleRemoveButtonClick();
              }}
              title="Excluir perfil definitivamente."
            >
              <Trash2 size={16} />
            </Buttons.IconButton>
            <button className="collapse-button" onClick={toggleExpansion}>
              <img
                src={require(`../../assets/${arrowClass}.svg`)}
                alt={arrowClass}
                width={20}
                className={arrowClass}
              />
            </button>
          </div>
        </Collapse.Content>
        <Collapse.ItemContent className={isExpanded ? 'active' : ''}>
          <ParallelList>
            {permissionsProfile &&
              permissionsProfile.length > 0 &&
              permissionsProfile.map((item: any, index: any) => (
                <li key={index}>
                  <img
                    src={permissoes.includes(item.area) ? Check : Close}
                    width={14}
                  />
                  {item.descricao}
                </li>
              ))}
          </ParallelList>
          {log.dataCriacaoLog !== null && (
            <div className="log-content">
              <p>Atualizado por: {log.usuarioAlteracaoPerfil}</p>
              <p>
                Atualizado em:{' '}
                {format(new Date(log.dataCriacaoLog), 'dd/MM/yyyy HH:mm')}
              </p>
            </div>
          )}
        </Collapse.ItemContent>
      </Collapse.List>
    </S.CollapseWrapper>
  );
};

export default CollapseList;
